// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * [[Attendee]] contains the information of an attendee.
 */
export default class Attendee {
  /**
   * The attendee id of an attendee.
   */
  attendeeId: string;
  /**
   * The external user id of an attendee.
   */
  externalUserId: string;
}
